module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<p>Your content here.</p>\n\n';

}
return __p
}